'use client';
import cn from 'classnames';
import Slider from 'react-slick';

import VideoCover from '../VideoCover/VideoCover';

import styles from './WRHeader.module.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { useBreakpoints } from '@hooks/useBreakpoints';
function WRHeader({ title, description, articles }) {
  const { isBreakpointUp } = useBreakpoints();
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplaySpeed: 5000,
    autoplay: isBreakpointUp('xl'),
    cssEase: 'ease-in-out',
    slidesToShow: isBreakpointUp('lg') ? (isBreakpointUp('xl') ? 3 : 2) : 1,
    slidesToScroll: 1,
    arrows: !isBreakpointUp('lg'),
  };
  return (
    <div className={cn('w-full px-5', styles.header)}>
      <div className="container mx-auto">
        <h1>{title}</h1>
        <div className="text-white dark:text-white text-justify text-sm mb-8 md:text-lg md:mb-10">
          {description}
        </div>
        <Slider className={styles.slider} {...settings}>
          {articles.map((article) => (
            <VideoCover
              key={`${Date.now()}${article.id}`}
              article={article}
              variant="header"
            />
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default WRHeader;
